/**
 * NOTE: This file is separate from userland components (componentsByType.ts) because it includes
 * the VERY HEAVY text editor. Separating the files helps code splitting and
 * to ensure that users don't download extra unneeded large files.
 */
import { VueConstructor } from 'vue/types/umd';
import { ElementType, DraggablePlaceholder, SectionType } from '../model';
import EditableHeadingComponent from '../components/Heading/HeadingEditor.vue';
import EditableTextComponent from '../components/Text/TextEditor.vue';
import EditableButtonComponent from '../components/Button/ButtonEditor.vue';
import EditableImageComponent from '../components/Image/ImageEditor.vue';
import EditableSurveyComponent from '../components/Survey/SurveyEditor.vue';
import EditableVideoComponent from '../components/Video/VideoEditor.vue';
import EditableFullWidthList from '../components/FullWidthList/FullWidthListEditor.vue';
import TextPlaceholder from '../components/Text/TextPlaceholder.vue';
import HeadingPlaceholder from '../components/Heading/HeadingPlaceholder.vue';
import ButtonComponentPlaceholder from '../components/Button/ButtonPlaceholder.vue';
import ImageComponentPlaceholder from '../components/Image/ImagePlaceholder.vue';
import SurveyComponentPlaceholder from '../components/Survey/SurveyPlaceholder.vue';
import VideoComponentPlaceholder from '../components/Video/VideoPlaceholder.vue';
import FullWidthListPlaceholder from '../components/FullWidthList/FullWidthListPlaceholder.vue';

export const EDITORS_BY_TYPE: Record<ElementType | SectionType, VueConstructor> = {
	[ElementType.HEADING]: EditableHeadingComponent as VueConstructor,
	[ElementType.TEXT]: EditableTextComponent as VueConstructor,
	[ElementType.BUTTON]: EditableButtonComponent as VueConstructor,
	[ElementType.IMAGE]: EditableImageComponent as VueConstructor,
	[ElementType.SURVEY]: EditableSurveyComponent as VueConstructor,
	[ElementType.VIDEO]: EditableVideoComponent as VueConstructor,
	[SectionType.FULL_WIDTH_LIST]: EditableFullWidthList as VueConstructor,
};

export const ELEMENT_PLACEHOLDERS: DraggablePlaceholder<ElementType>[] = [
	{
		type: ElementType.HEADING,
		component: HeadingPlaceholder as VueConstructor,
	},
	{
		type: ElementType.TEXT,
		component: TextPlaceholder as VueConstructor,
	},
	{
		type: ElementType.BUTTON,
		component: ButtonComponentPlaceholder as VueConstructor,
	},
	{
		type: ElementType.IMAGE,
		component: ImageComponentPlaceholder as VueConstructor,
	},
	{
		type: ElementType.SURVEY,
		component: SurveyComponentPlaceholder as VueConstructor,
	},
	{
		type: ElementType.VIDEO,
		component: VideoComponentPlaceholder as VueConstructor,
	},
];

export const SECTION_PLACEHOLDERS: DraggablePlaceholder<SectionType>[] = [
	{
		type: SectionType.FULL_WIDTH_LIST,
		component: FullWidthListPlaceholder as VueConstructor,
	},
];
